const parseJwt = (token) => {
  try {
    // Split the token into parts
    const base64Url = token.split(".")[1];

    // Replace URL-specific characters with regular base64 characters
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    // Decode the base64 string
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default parseJwt;
